import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.specialProcessDefinition],
        config: {
            headerName: getLocalizedString("processCode"),
            field: "code",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.specialProcessDefinition],
        config: {
            headerName: getLocalizedString("processName"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.specialProcessDefinition],
        config: {
            headerName: getLocalizedString("group"),
            field: "groupString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.specialProcessDefinition],
        config: {
            headerName: getLocalizedString("active"),
            field: "activeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.specialProcessDefinition],
        config: {
            headerName: getLocalizedString("type"),
            field: "typeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.specialProcessDefinition],
        config: {
            headerName: getLocalizedString("functionOnStart"),
            field: "functionStartString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.specialProcessDefinition],
        config: {
            headerName: getLocalizedString("conceptToProcess"),
            field: "concept",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.specialProcessDefinition],
        config: {
            headerName: getLocalizedString("functionWhenFinished"),
            field: "functionEndString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.specialProcessDefinition],
        config: {
            headerName: getLocalizedString("executionMode"),
            field: "executionString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.specialProcessDefinition],
        config: {
            headerName: getLocalizedString("gridTableMenuOrAssociatedQuery"),
            field: "gridString",
            filter: "agSetColumnFilter",
        }
    },
]